var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStepperDone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2F2E99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.153 11.3298C21.9486 11.1447 21.6792 11.0482 21.4038 11.0615C21.1284 11.0748 20.8695 11.1968 20.684 11.4008L14.34 18.3868L11.275 15.2708C11.0804 15.0798 10.8187 14.9728 10.546 14.9729C10.2734 14.973 10.0117 15.0802 9.81725 15.2713C9.62283 15.4624 9.51123 15.7223 9.5065 15.9949C9.50178 16.2675 9.60431 16.5311 9.792 16.7288L13.629 20.6288C13.7257 20.7273 13.841 20.8055 13.9682 20.8589C14.0954 20.9123 14.232 20.9398 14.37 20.9398H14.39C14.5316 20.937 14.6712 20.9053 14.8002 20.8467C14.9291 20.788 15.0448 20.7037 15.14 20.5988L22.224 12.7988C22.4091 12.5945 22.5056 12.325 22.4923 12.0496C22.479 11.7742 22.357 11.5153 22.153 11.3298Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStepperDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stepper-done.073b62da.svg";
export { ForwardRef as ReactComponent };